// ============================================================================
// ADVOCATE ENDPOINTS
// ============================================================================
// BASE_PATH must match backend AdvocateController → /Advocate.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const ADVOCATE_BASE_PATH = '/Advocate';

export const advocateEndpoints = {
  list: () => buildEndpoint(ADVOCATE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${ADVOCATE_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${ADVOCATE_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(ADVOCATE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${ADVOCATE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${ADVOCATE_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${ADVOCATE_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default advocateEndpoints;
